export const labelColor = '#666';
export const labelHoverColor = '#000';
export const boxColor = 0xff0000;
